import erj190Img from "../../../assets/imgs/about-us/fleet/redesign/E190-01.png";
import erj190AltImg from "../../../assets/imgs/about-us/fleet/redesign/E190-05.png";
import b737CargoImg from "../../../assets/imgs/about-us/fleet/redesign/737max-05.png";
import b737MaxKukulcanImg from "../../../assets/imgs/about-us/fleet/redesign/Kukulcan-01.png";
import b737MaxKukulcanAltImg from "../../../assets/imgs/about-us/fleet/redesign/Kukulcan-05.png";
import b7878Img from "../../../assets/imgs/about-us/fleet/redesign/787-01.png";
import b7878AltImg from "../../../assets/imgs/about-us/fleet/redesign/787-05.png";
import b7879Img from "../../../assets/imgs/about-us/fleet/redesign/Quetzalcoatl-01.png";
import b7879QuetzalcoatlAltImg from "../../../assets/imgs/about-us/fleet/redesign/Quetzalcoatl-05.png";

export const fleetImages = {
  "erj-190": erj190Img,
  "erj-190-05": erj190AltImg,
  "b737-700": b737CargoImg,
  "b737-800": b737CargoImg,
  "b737-max-kukulcan": b737MaxKukulcanImg,
  "b737-max-kukulcan-05": b737MaxKukulcanAltImg,
  "b787-8": b7878Img,
  "b787-8-05": b7878AltImg,
  "b787-9": b7879Img,
  "b787-9-quetzalcoatl-05": b7879QuetzalcoatlAltImg,
};
